// extracted by css-extract-rspack-plugin
export default {"root":"root-QD_lg6","inner":"inner-ZPQ9_S","icon":"icon-u5W6uF"};